<template>
  <div>
      <div id="map"></div>
    <div style="margin-left:5px">
      <vs-row vs-w="12">
        <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-input :label="$t('NameZone')" v-model="nameZone" class="w-full" />
          <vs-divider></vs-divider>
          <b>{{ $t('VesselGroup') }}</b>
          <div class="demo-alignment" style="flex-wrap: nowrap;">
            <vs-checkbox v-model="selectVesselGroup" vs-value="1">Excise-tanker</vs-checkbox>
            <vs-checkbox v-model="selectVesselGroup" vs-value="2">Excise-tanker-shipping</vs-checkbox>
          </div>
          <vs-divider></vs-divider>
          <b>{{$t('DetectionRule')}}</b>
          <vs-select
            placeholder="Select Event"
            class="selectExample w-full"
            label="Event"
            v-model="rule.event"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in options1"
            />
          </vs-select>
          <div class="demo-alignment" style="flex-wrap: nowrap;margin-top:5px">
            <vs-input :label="$t('StopRadius')" v-model="rule.stop_radius" class="w-full" />
            <vs-input :label="$t('StopPeriod')" v-model="rule.stop_period" class="w-full" />
          </div>
          <label for="email" style="font-size:12px;margin-top:60px;">{{$t('EmailList')}}</label>
          <vs-textarea
            id="email"
            v-model="rule.email_list"
            style="background-color: white;border: 1px solid rgba(0, 0, 0, 0.2);"
          />
          <vs-button
            @click="addDetectionRules()"
            class="w-full"
            color="warning"
            icon-pack="feather"
            icon="icon-plus"
          >{{ $t('Add') }}</vs-button>
        </vs-col>

        <vs-col vs-lg="8" vs-sm="8" vs-xs="12" class="mt-3">
          <div class="demo-alignment" style="flex-wrap: nowrap;margin-top:5px">
            <vs-button
              style="margin:3px"
              @click="selectMove()"
              class="w-full"
              color="primary"
              icon-pack="feather"
              icon="icon-move"
            >{{$t('Selected')}}</vs-button>
            <vs-button
              style="margin:3px"
              @click="polygon=true,cricle=false,polyline=false,darwPolygon()"
              class="w-full"
              color="success"
              icon-pack="feather"
              icon="icon-alert-octagon"
            >{{$t('Polygon')}}</vs-button>
            <vs-button
              style="margin:3px"
              @click="cricle=true,polygon=false,polyline=false,darwCircle()"
              class="w-full"
              color="warning"
              icon-pack="feather"
              icon="icon-circle"
            >{{$t('Circle')}}</vs-button>
            <vs-button
              style="margin:3px"
              @click="polyline=true,cricle=false,polygon=false,darwPolyLine()"
              class="w-full"
              color="primary"
              icon-pack="feather"
              icon="icon-minus"
            >{{$t('Polyline')}}</vs-button>
          </div>
          <br />
          <div id="color-palette"></div>
          <div class="vx-row">
            <div class="lg:w-1/2 md:w-1/2 lx:w-1/2 pr-1">
              <vs-button
                class="w-full"
                @click="insertZone()"
                icon-pack="feather"
                icon="icon-save"
              >{{ $t('Save') }}</vs-button>
            </div>
            <div class="lg:w-1/2 md:w-1/2 lx:w-1/2 pl-1">
              <vs-button
                id="delete-button"
                class="w-full"
                color="danger"
                icon-pack="feather"
                icon="icon-trash-2"
              >{{ $t('Delete') }}</vs-button>
            </div>
          </div>

          <VuePerfectScrollbar class="scroll-area--dataDrawing pt-4 pb-6 pr-2">
            <vs-list-header :title="$t('Polygon')"></vs-list-header>
            <vs-list>
              <vs-list-item v-for=" (polygon,index) in zone_polygons" :key="index">
                <b>polygon {{index+1}}.</b>
                {{polygon}}
              </vs-list-item>
            </vs-list>
            <vs-list-header :title="$t('Circle')"></vs-list-header>
            <vs-list>
              <vs-list-item v-for="(cricle,index) in zone_circles" :key="index" class="ml-0">
                <b>Cricle {{index+1}}.</b>
                {{cricle}}
              </vs-list-item>
            </vs-list>
            <vs-list-header :title="$t('Polyline')"></vs-list-header>
            <vs-list>
              <vs-list-item v-for=" (line,index) in zone_lines" :key="index">
                <b>Line {{index+1}}.</b>
                {{line}}
              </vs-list-item>
            </vs-list>
            <vs-list-header :title="$t('DetectionRule')"></vs-list-header>
            <vs-list>
              <vs-list-item v-for=" (rules,index) in detection_rules" :key="index">
                <b>rules {{index+1}}.</b>
                {{rules}}
              </vs-list-item>
            </vs-list>
          </VuePerfectScrollbar>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/gmap/gmaps";
import { SERVER_SYNC_INTERVAL, API_BASE_URL } from "@/constants";
import { lstat } from "fs";
import { mapState } from "vuex";
import { isRegExp } from "util";
export default {
  data() {
    return {
      selectVesselGroup: [],
      stopRadius: "",
      stopperiod: "",
      email: "",
      selectEvent: [],
      options1: [
        { text: "Enter", value: "enter" },
        { text: "Exit", value: "exit" },
        { text: "Cross", value: "cross" },
        { text: "Idle", value: "idle" }
      ],
      google: null,
      geocoder: null,
      nameZone: null,
      map: null,
      drawingManager: null,
      selectedShape: null,
      colors: ["#1E90FF", "#FF1493", "#32CD32", "#FF8C00", "#4B0082"],
      selectedColor: null,
      colorButtons: {},
      typeExciseTanker: null,
      typeExciseTankerShipping: null,
      drawingtype: null,
      myCoordinates: "",
      zone_polygons: [],
      zone_circles: [],
      zone_lines: [],
      rule: {
        event: "",
        stop_radius: "",
        stop_period: "",
        email_list: ""
      },
      detection_rules: [],
      chkDelete: "",
      zone: {
        to_s: "",
        name: ""
      },
      accessEmail: "",
      accessToken: "",
      cricle: false,
      polygon: false,
      polyline: false,
      zoneEdit: {},
      fullUrlZone: "",
      urlZone: "",
      dataLatLngEdit: []
    };
  },

  async mounted() {
    this.$vs.loading();
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.$store.dispatch("updateTitlePage", "EditZones");
    // this.fullUrlZone = this.$store.state.editZone.url;
    this.fullUrlZone = JSON.parse(localStorage.getItem('updateEditZone')) 
    
    console.log("full url", this.fullUrlZone);
    this.urlZone = this.fullUrlZone.substring(28);
    console.log("sub url", this.urlZone);
    this.initMap();
    this.all = require("../../milesSea/all.json");
    await axios
      .get(`${API_BASE_URL}${this.urlZone}`, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
      .then(response => {
        this.nameZone = response.data.name;
        this.zone_polygons = response.data.zone_polygons;
        this.zone_circles = response.data.zone_circles;
        this.zone_lines = response.data.zone_lines;
        this.convertLstLng();

        this.$vs.loading.close();
      })
      .catch(error => {
        console.log("Error call apis :", error);
      });
  },
  watch: {},
  methods: {
    darwPolygonok(pathss) {
      console.log("dsss", pathss);

      var paths = pathss;
      var pLine = new google.maps.Polyline({
        path: paths,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1,
        strokeWeight: 3
      });
      pLine.setMap(this.map);
      var pt = new google.maps.LatLng(paths[0].lat, paths[0].lng);
      this.map.setCenter(pt);
      this.map.setZoom(6);
    },
    convertLstLng() {
      console.log("convert working...", this.zone_polygons);
      for (let i = 0; i < this.zone_polygons.length; i++) {
        let date = JSON.stringify(this.zone_polygons[i].area_data);
        let len = date.length;
        let i = 0;
        let rultData = [];
        let tmpData = "";
        while (i < len) {
          if (i == 0) {
            tmpData += ' [{ "lng" : ';
          } else {
            switch (date[i]) {
              case ",":
                tmpData += "},";

                tmpData += ' { "lng" : ';
                break;
              case " ":
                tmpData += ', "lat" : ';
                break;
              default:
                // code block

                if (i + 1 == len) {
                  tmpData += date[i - 1];
                } else {
                  tmpData += date[i];
                }
            }
          }

          i++;
        }
        tmpData += " } ]";

        console.log(tmpData);

        console.log("dsadsa", JSON.parse(tmpData));
        setTimeout(() => {
          this.darwPolygonok(JSON.parse(tmpData));
        }, 1000);
      }
    },
    addDetectionRules() {
      console.log("add rule");
      this.detection_rules.push(this.rule);
      this.rule = {};
    },
    selectMove() {
      if (this.drawingManager) {
        this.drawingManager.setDrawingMode(null);
        this.drawingManager = null;
      }
    },
    insertZone() {
      //manage data polygon
      var dataZone = [];
      for (var i = 0; i < this.zone_polygons.length; i++) {
        dataZone.push({ area_data: this.zone_polygons[i] });
      }
      var insetZoneData = {};
      insetZoneData = this.toObject(dataZone);

      //manage data circle
      var dataCircle = [];
      for (var i = 0; i < this.zone_circles.length; i++) {
        dataCircle.push(this.zone_circles[i]);
      }
      var insertCircle = {};
      insertCircle = this.toObjectCircle(dataCircle);

      //manage data line
      var dataLine = [];
      for (var i = 0; i < this.zone_lines.length; i++) {
        dataLine.push({ path_data: this.zone_lines[i] });
      }
      var insertLine = {};
      insertLine = this.toObjectLine(dataLine);

      //manage data evnt
      var dataEvent = [];
      for (var i = 0; i < this.detection_rules.length; i++) {
        dataEvent.push(this.detection_rules[i]);
      }
      var insertEvent = {};
      insertEvent = this.toObjectEvent(dataEvent);

      // manage to serve
      var zone = {
        name: this.nameZone,
        vessel_group_ids: this.selectVesselGroup,
        zone_polygons_attributes: insetZoneData,
        zone_circles_attributes: insertCircle,
        zone_lines_attributes: insertLine,
        detection_rules_attributes: insertEvent
      };
      console.log("zone go insert", zone);
      axios
        .post(
          `${API_BASE_URL}/admin/zones.json`,
          { zone },
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          }
        )
        .then(response => {
          console.log(response.data);
          this.$vs.notify({
            title: this.$t("Success"),
            text: this.$t("เพิ่มข้อมูล สำเร็จ"),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
            time: 5000
          });
          this.nameZone = "";
          this.zone_polygons = [];
          this.zone_circles = [];
          this.zone_lines = [];
          this.$router.push("Listzone");
        })
        .catch(error => {
          console.log(error);
          this.$vs.notify({
            title: this.$t("Error"),
            text: error,
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
            time: 5000
          });
        });
    },
    toObject(arr) {
      var rv = {};
      for (var i = 0; i < arr.length; ++i) rv[i] = arr[i];
      console.log("Rv polygon : ", rv);
      return rv;
    },
    toObjectCircle(arr) {
      var rv = {};
      for (var i = 0; i < arr.length; ++i) rv[i] = arr[i];
      console.log("Rv cicle : ", rv);
      return rv;
    },
    toObjectLine(arr) {
      var rv = {};
      for (var i = 0; i < arr.length; ++i) rv[i] = arr[i];
      console.log("Rv cicle : ", rv);
      return rv;
    },
    toObjectEvent(arr) {
      var rv = {};
      for (var i = 0; i < arr.length; ++i) rv[i] = arr[i];
      console.log("Rv cicle : ", rv);
      return rv;
    },
    fnInsertToObPolygon() {
      this.zone_polygons.push(this.myCoordinates);
      this.myCoordinates = "";
    },
    fnInsertToObline() {
      this.zone_lines.push(this.myCoordinates);
      this.myCoordinates = "";
    },
    async initMap() {
      try {
        this.google = await gmapsInit();
        this.geocoder = new google.maps.Geocoder();
        var latlng = new google.maps.LatLng(11.523924, 100.518503);
        var options = {
          zoom: 6,
          center: latlng,
          streetViewControl: false,
          mapTypeControl: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          fullscreenControl: true,
          gestureHandling: "greedy"
        };

        this.map = new google.maps.Map(this.$el.querySelector("#map"), options);
        google.maps.event.trigger(this.map, "resize");
        this.fnAreaColor();
      } catch (error) {
        console.error(error);
      }
    },
    fnAreaColor() {
      this.map.data.addGeoJson(this.all);
      this.map.data.setStyle(function(feature) {
        var color = feature.getProperty("color");
        if (color == "red") {
          color = "red";
        } else if (color == "green") {
          color = "#10FD1E";
        } else if (color == "blue") {
          color = "#00BDFF";
        }
        return {
          fillColor: color,
          strokeWeight: 0
        };
      });
    },
    // Draw manager
    clearSelection() {
      if (this.selectedShape) {
        this.selectedShape.setEditable(false);
        this.selectedShape = null;
      }
    },
    setSelection(shape) {
      this.clearSelection();
      this.selectedShape = shape;
      shape.setEditable(true);
      this.selectColor(shape.get("fillColor") || shape.get("strokeColor"));
    },
    deleteSelectedShape() {
      if (this.selectedShape) {
        this.selectedShape.setMap(null);
      }
      if (this.polygon == true) {
        for (let i = 0; i < this.zone_polygons.length; i++) {
          if (this.zone_polygons[i] == this.chkDelete) {
            this.zone_polygons.splice(i, 1);
          }
        }
      }
      if (this.cricle == true) {
        for (let j = 0; j < this.zone_circles.length; j++) {
          if (
            this.zone_circles[j].longitude == this.chkDelete.longitude &&
            this.zone_circles[j].latitude == this.chkDelete.latitude
          ) {
            this.zone_circles.splice(j, 1);
          }
        }
      }
      if (this.polyline == true) {
        console.log("del line");
        for (let j = 0; j < this.zone_lines.length; j++) {
          if (this.zone_lines[j] == this.chkDelete) {
            this.zone_lines.splice(j, 1);
          }
        }
      }
    },
    selectColor(color) {
      this.selectedColor = color;
      for (var i = 0; i < this.colors.length; ++i) {
        var currColor = this.colors[i];
        // this.colorButtons[currColor].style.border =
        //   currColor == color ? "2px solid #789" : "2px solid #fff";
      }

      // Retrieves the current options from the drawing manager and replaces the
      // stroke or fill color as appropriate.
      var polylineOptions = this.drawingManager.get("polylineOptions");
      polylineOptions.strokeColor = color;
      this.drawingManager.set("polylineOptions", polylineOptions);

      var rectangleOptions = this.drawingManager.get("rectangleOptions");
      rectangleOptions.fillColor = color;
      this.drawingManager.set("rectangleOptions", rectangleOptions);

      var circleOptions = this.drawingManager.get("circleOptions");
      circleOptions.fillColor = color;
      this.drawingManager.set("circleOptions", circleOptions);

      var polygonOptions = this.drawingManager.get("polygonOptions");
      polygonOptions.fillColor = color;
      this.drawingManager.set("polygonOptions", polygonOptions);
    },
    setSelectedShapeColor(color) {
      if (this.selectedShape) {
        if (
          this.selectedShape.type == google.maps.drawing.OverlayType.POLYLINE
        ) {
          this.selectedShape.set("strokeColor", color);
        } else {
          this.selectedShape.set("fillColor", color);
        }
      }
    },
    makeColorButton(color) {
      var button = document.createElement("span");
      button.className = "color-button";
      button.style.backgroundColor = color;
      google.maps.event.addDomListener(button, "click", () => {
        this.selectColor(color);
        this.setSelectedShapeColor(color);
      });

      return button;
    },
    buildColorPalette() {
      var colorPalette = document.getElementById("color-palette");
      for (var i = 0; i < this.colors.length; ++i) {
        var currColor = this.colors[i];
        var colorButton = this.makeColorButton(currColor);
        colorPalette.appendChild(colorButton);
        this.colorButtons[currColor] = colorButton;
      }
      this.selectColor(this.colors[0]);
    },
    darwPolygon() {
      this.selectMove();
      var polyOptions = {
        strokeWeight: 0,
        fillOpacity: 0.45,
        editable: true
      };
      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        polygonOptions: polyOptions,
        markerOptions: {
          draggable: true
        },
        polylineOptions: {
          editable: true
        },
        rectangleOptions: polyOptions,
        circleOptions: polyOptions,
        polygonOptions: polyOptions,
        map: this.map
      });
      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        e => {
          this.chkDelete = "";
          this.cricle = false;
          this.polygon = true;
          this.polyline = false;
          // Switch back to non-drawing mode after drawing a shape.
          // this.drawingManager.setDrawingMode(null);

          var newShape = e.overlay;
          var paths = e.overlay.getPath().getArray();
          var myCoordinatesss;
          newShape.type = e.type;
          google.maps.event.addListener(newShape, "click", e => {
            this.cricle = false;
            this.polygon = true;
            this.polyline = false;

            var paths = newShape.getPath().getArray();
            this.chkDelete = "";
            this.myCoordinates = "";
            for (var i = 0; i < paths.length; i++) {
              var lat = paths[i].lat();
              var lng = paths[i].lng();
              this.myCoordinates = `${this.myCoordinates},${lng.toFixed(
                6
              )} ${lat.toFixed(6)}`;
              this.chkDelete = `${this.chkDelete},${lng.toFixed(
                6
              )} ${lat.toFixed(6)}`;
            }
            this.setSelection(newShape);
          });
          this.setSelection(newShape);

          this.myCoordinates = "";
          for (var i = 0; i < paths.length; i++) {
            var lat = paths[i].lat();
            var lng = paths[i].lng();
            this.myCoordinates = `${this.myCoordinates},${lng.toFixed(
              6
            )} ${lat.toFixed(6)}`;
            this.chkDelete = `${this.chkDelete},${lng.toFixed(6)} ${lat.toFixed(
              6
            )}`;
          }
          this.fnInsertToObPolygon();
        }
      );

      google.maps.event.addListener(
        this.drawingManager,
        "polygoncomplete",
        polygon => {
          google.maps.event.addListener(polygon, "click", e => {
            this.chkDelete = "";
            this.cricle = false;
            this.polygon = true;
            this.polyline = false;
            var paths = polygon.getPath().getArray();
            this.myCoordinates = "";
            this.chkDelete = "";
            for (var i = 0; i < paths.length; i++) {
              var lat = paths[i].lat();
              var lng = paths[i].lng();
              this.myCoordinates = `${this.myCoordinates},${lng.toFixed(
                6
              )} ${lat.toFixed(6)}`;
              this.chkDelete = `${this.chkDelete},${lng.toFixed(
                6
              )} ${lat.toFixed(6)}`;
            }
            var arr = [];
            polygon.getPath().forEach(latLng => {
              arr.push(latLng.toString());
            });
          });
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "drawingmode_changed",
        this.clearSelection
      );
      google.maps.event.addListener(this.map, "click", this.clearSelection);
      google.maps.event.addDomListener(
        document.getElementById("delete-button"),
        "click",
        this.deleteSelectedShape
      );
    },
    darwCircle() {
      this.selectMove();
      var polyOptions = {
        strokeWeight: 0,
        fillOpacity: 0.45,
        editable: true
      };
      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.CIRCLE,
        drawingControl: false,
        polygonOptions: polyOptions,
        markerOptions: {
          draggable: true
        },
        polylineOptions: {
          editable: true
        },
        rectangleOptions: polyOptions,
        circleOptions: polyOptions,
        polygonOptions: polyOptions,
        map: this.map
      });
      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        e => {
          // this.drawingManager.setDrawingMode(null);
          if (e.type != google.maps.drawing.OverlayType.MARKER) {
            var newShape = e.overlay;
            newShape.type = e.type;

            google.maps.event.addListener(newShape, "click", e => {
              this.chkDelete = "";
              this.cricle = true;
              this.polygon = false;
              this.polyline = false;
              this.chkDelete = {
                longitude: newShape
                  .getCenter()
                  .lng()
                  .toFixed(6),
                latitude: newShape
                  .getCenter()
                  .lat()
                  .toFixed(6),
                radius: newShape.getRadius().toFixed(6)
              };
              this.setSelection(newShape);
              console.log("select circle");
            });
            this.setSelection(newShape);
          } else {
          }
          this.activeDraw = true;
        }
      );

      google.maps.event.addListener(
        this.drawingManager,
        "circlecomplete",
        circle => {
          this.chkDelete = "";
          this.cricle = true;
          this.polygon = false;
          this.polyline = false;
          this.zone_circles.push({
            longitude: circle
              .getCenter()
              .lng()
              .toFixed(6),
            latitude: circle
              .getCenter()
              .lat()
              .toFixed(6),
            radius: circle.getRadius().toFixed(6)
          });
          this.chkDelete = {
            longitude: circle
              .getCenter()
              .lng()
              .toFixed(6),
            latitude: circle
              .getCenter()
              .lat()
              .toFixed(6),
            radius: circle.getRadius().toFixed(6)
          };
          google.maps.event.addListener(circle, "click", e => {
            this.chkDelete = "";
            this.cricle = true;
            this.polygon = false;
            this.polyline = false;
            this.chkDelete = {
              longitude: circle
                .getCenter()
                .lng()
                .toFixed(6),
              latitude: circle
                .getCenter()
                .lat()
                .toFixed(6),
              radius: circle.getRadius().toFixed(6)
            };
          });
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "drawingmode_changed",
        this.clearSelection
      );
      google.maps.event.addListener(this.map, "click", this.clearSelection);
      google.maps.event.addDomListener(
        document.getElementById("delete-button"),
        "click",
        this.deleteSelectedShape
      );
    },
    darwPolyLine() {
      this.cricle = false;
      this.polygon = false;
      this.polyline = true;
      this.selectMove();
      var polyOptions = {
        strokeWeight: 0,
        fillOpacity: 0.45,
        editable: true
      };

      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYLINE,
        drawingControl: false,
        polygonOptions: polyOptions,
        markerOptions: {
          draggable: true
        },
        polylineOptions: {
          editable: true
        },
        rectangleOptions: polyOptions,
        circleOptions: polyOptions,
        polygonOptions: polyOptions,
        map: this.map
      });
      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        e => {
          this.cricle = false;
          this.polygon = false;
          this.polyline = true;
          if (e.type != google.maps.drawing.OverlayType.MARKER) {
            var newShape = e.overlay;
            newShape.type = e.type;
            google.maps.event.addListener(newShape, "click", e => {
              this.cricle = false;
              this.polygon = false;
              this.polyline = true;
              var line = newShape.getPath().getArray();
              this.chkDelete = "";
              for (var i = 0; i < line.length; i++) {
                var lat = line[i].lat();
                var lng = line[i].lng();
                this.chkDelete = `${this.chkDelete},${lng.toFixed(
                  6
                )} ${lat.toFixed(6)}`;
              }
              console.log("chk del : ,", this.chkDelete);
              this.setSelection(newShape);
            });
            this.setSelection(newShape);
          } else {
          }
          var line = e.overlay.getPath().getArray();
          this.chkDelete = "";
          this.myCoordinates = "";
          for (var i = 0; i < line.length; i++) {
            var lat = line[i].lat();
            var lng = line[i].lng();
            console.log("lat", lat);
            console.log("lng", lng);
            this.myCoordinates = `${this.myCoordinates},${lng.toFixed(
              6
            )} ${lat.toFixed(6)}`;
            this.chkDelete = `${this.chkDelete},${lng.toFixed(6)} ${lat.toFixed(
              6
            )}`;
          }
          this.zone_lines.push(this.myCoordinates);
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "polylinecomplete",
        polyline => {
          google.maps.event.addListener(polyline, "click", e => {
            this.cricle = false;
            this.polygon = false;
            this.polyline = true;

            var line = newShape.getPath().getArray();
            this.chkDelete = "";
            for (var i = 0; i < line.length; i++) {
              var lat = line[i].lat();
              var lng = line[i].lng();
              this.chkDelete = `${this.chkDelete},${lng.toFixed(
                6
              )} ${lat.toFixed(6)}`;
            }
          });
          console.log("Line");
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "drawingmode_changed",
        this.clearSelection
      );
      google.maps.event.addListener(this.map, "click", this.clearSelection);
      google.maps.event.addDomListener(
        document.getElementById("delete-button"),
        "click",
        this.deleteSelectedShape
      );
    },
    initDrawManager() {
      var polyOptions = {
        strokeWeight: 0,
        fillOpacity: 0.45,
        editable: true
      };
      // Creates a drawing manager attached to the map that allows the user to draw
      // markers, lines, and shapes.
      this.drawingManager = new google.maps.drawing.DrawingManager({
        //drawingMode: google.maps.drawing.OverlayType.RECTANGLE,
        drawingControl: false,
        drawingControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_RIGHT,
          drawingModes: [
            google.maps.drawing.OverlayType.MARKER,
            google.maps.drawing.OverlayType.CIRCLE,
            google.maps.drawing.OverlayType.POLYGON,
            google.maps.drawing.OverlayType.POLYLINE,
            google.maps.drawing.OverlayType.RECTANGLE
          ]
        },
        markerOptions: {
          draggable: true
        },
        polylineOptions: {
          editable: true
        },
        rectangleOptions: polyOptions,
        circleOptions: polyOptions,
        polygonOptions: polyOptions,
        map: this.map
      });

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        e => {
          // Switch back to non-drawing mode after drawing a shape.
          // this.drawingManager.setDrawingMode(null);

          if (e.type != google.maps.drawing.OverlayType.MARKER) {
            var newShape = e.overlay;
            newShape.type = e.type;
            google.maps.event.addListener(newShape, "click", e => {
              this.setSelection(newShape);
            });
            this.setSelection(newShape);
          } else {
          }
          console.log("Draw Success ....");
        }
      );

      google.maps.event.addListener(
        this.drawingManager,
        "polygoncomplete",
        polygon => {
          google.maps.event.addListener(polygon, "click", e => {
            var arr = [];
            polygon.getPath().forEach(latLng => {
              arr.push(latLng.toString());
            });
            alert(arr.join(",\n"));
          });
          console.log("Poligon");
        }
      );

      google.maps.event.addListener(
        this.drawingManager,
        "circlecomplete",
        circle => {
          google.maps.event.addListener(circle, "click", e => {
            alert(circle.getCenter() + " : " + circle.getRadius());
          });
          console.log("Crlcle");
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "markercomplete",
        marker => {
          google.maps.event.addListener(marker, "click", e => {
            alert(marker.getPosition());
          });
          console.log("Marker");
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "polylinecomplete",
        polyline => {
          google.maps.event.addListener(polyline, "click", e => {
            var arr = [];
            polyline.getPath().forEach(latLng => {
              arr.push(latLng.toString());
            });
            alert(arr.join(",\n"));
          });
          console.log("Line");
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "rectanglecomplete",
        rectangle => {
          google.maps.event.addListener(rectangle, "click", e => {
            alert(rectangle.getBounds());
          });
          console.log("Rectangel");
        }
      );

      // Clear the current selection when the drawing mode is changed, or when the
      // map is clicked.
      google.maps.event.addListener(
        this.drawingManager,
        "drawingmode_changed",
        this.clearSelection
      );
      google.maps.event.addListener(this.map, "click", this.clearSelection);
      google.maps.event.addDomListener(
        document.getElementById("delete-button"),
        "click",
        this.deleteSelectedShape
      );

      this.buildColorPalette();
    },
    showArrays(event) {
      var vertices = this.getPath();

      var contentString =
        "<b>Bermuda Triangle polygon</b><br>" +
        "Clicked location: <br>" +
        event.latLng.lat() +
        "," +
        event.latLng.lng() +
        "<br>";

      // Iterate over the vertices.
      for (var i = 0; i < vertices.getLength(); i++) {
        var xy = vertices.getAt(i);
        contentString +=
          "<br>" + "Coordinate " + i + ":<br>" + xy.lat() + "," + xy.lng();
      }

      // Replace the info window's content and position.
      infoWindow.setContent(contentString);
      infoWindow.setPosition(event.latLng);

      infoWindow.open(this.map);
    }
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>
<style lang="scss" scoped>

#map {
  position: relative;
  width: 100%;
  height: 60%;
}

.custom-pin {
  height: 1em;
  line-height: 1;
  width: 1em;
  padding: 0.7em;
  text-align: center;
  cursor: pointer;
  color: white;
  background: black;
  position: absolute;
  border-radius: 0.5em;
  font-size: 1em;
  font-weight: bold;
  transition: all 500ms;
}

.color-button {
  width: 30px;
  height: 30px;
  font-size: 0;
  margin: 2px;
  float: right;
  cursor: pointer;
}

.header-sidebar-draw {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar-draw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
.customizer-btn-drawingMap {
  position: fixed;
  top: 49%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 30000;
  color: white;
}
.customizer-btn-color-polygon {
  position: fixed;
  // margin-left: 80px;
  top: 90%;
  left: 89px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 30000;
  color: white;
}

#color-palette {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 30000;
  color: rgb(224, 31, 31);
}
.vs-list--slot {
  margin-left: 0;
}
.demo-alignment > * {
  margin-right: 9px;
  margin-top: 0;
}
</style>
